import { createSelector } from 'reselect';
import { State } from 'models';
import { orderByType } from 'utils';
import _orderBy from 'lodash/orderBy';
import get from 'lodash/get';

const selectConsumptions = (state: State) => state.consumption.consumptions;
export const selectConsumptionsSortParams = (state: State) =>
  state.consumption.sortParams;

export const getSortedConsumptions = createSelector(
  selectConsumptions,
  selectConsumptionsSortParams,
  (consumptions, sortParams) => {
    const { order, orderBy, type } = sortParams;
    return _orderBy(consumptions, (c) => orderByType(get(c, orderBy), type), [
      order || 'asc',
    ]);
  }
);
